import React from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';

const adminUuid = 'adminUuid';
const adminRoles = 'adminRoles';
const accessToken = 'accessToken';

const whitelist = [
  'a759a987-4c48-4d82-973d-89be5fe7a56d',
  'a845cd21-247a-455f-a3f8-3b4adc35bb33',
  '53b291b8-a471-4afa-8d25-a433a44dcb08',
  '9cd0c83a-3673-451a-875b-86c1d8acb493',
  'fdeadff8-b91e-4974-8e84-d7c9d1ed8def',
  '04e2b53c-50c5-4c12-b412-1958be9764e5',
  '7027dc2f-82ae-42e9-8b23-829efb059bab',
  '7279416f-f094-4d69-9adc-868c0618882e',
  '0a785187-ff97-427a-8299-0583554a4a64',
];

export const setAccessToken = token => Cookies.set(accessToken, token);

export const removeAccessToken = () => Cookies.remove(accessToken);

export const getAccessToken = () => Cookies.get(accessToken);

export const setAdminUuid = uuid => Cookies.set(adminUuid, uuid);

export const removeAdminUuid = () => Cookies.remove(adminUuid);

export const getAdminUuid = () => Cookies.get(adminUuid);

export const setAdminRoles = roles => Cookies.set(adminRoles, roles || null);

export const removeAdminRoles = () => Cookies.remove(adminRoles);

export const getAdminRoles = () => JSON.parse(Cookies.get(adminRoles) || null);

export const removeCookies = () => {
  removeAccessToken();
  removeAdminRoles();
  removeAdminUuid();
};

export const isAuthenticated = () => !!getAccessToken();

export const isSuperUser = () => whitelist.includes(getAdminUuid());

export const isSystemAdmin = () =>
  isSuperUser() || !!getAdminRoles()?.includes('system');

export const requireAuthentication = PageComponent => {
  function AuthenticatedComponent(props) {
    const { history } = props;

    if (isAuthenticated()) {
      return <PageComponent {...props} />;
    }
    history.push('/login');
    return null;
  }

  AuthenticatedComponent.propTypes = {
    history: PropTypes.object,
  };

  return AuthenticatedComponent;
};
